<template>
    <div class="search-guarantees">
        <v-autocomplete
            v-model="guarantees"
            :items="items"
            :search-input.sync="search"
            class="rounded-0"
            label="Garantie"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="label"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :clearable="true"
        />
    </div>
</template>

<script>
import { get, isNil, isEmpty, intersection } from "lodash";

export default {
    props: ["value", "annotationOptions", "displayedSubjectsByType"],
    data() {
        return {
            guarantees: null,
            search: null,
        };
    },
    watch: {
        async guarantees(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.guarantees = _value;
        },
    },
    computed: {
        items() {
            const subjectTypes = Object.keys(this.displayedSubjectsByType);
            return Object.keys(this.annotationOptions)
                .map(key => {
                    const isGenericGuarantee =
                        isNil(this.annotationOptions[key]["annotationType"]) ||
                        isEmpty(this.annotationOptions[key]["annotationType"]);
                    const isGuaranteeAnnotationTypeDisplayed = !isEmpty(
                        intersection(this.annotationOptions[key]["annotationType"], subjectTypes)
                    );
                    return this.annotationOptions[key]["type"] === "guarantee" &&
                        (isGenericGuarantee || isGuaranteeAnnotationTypeDisplayed)
                        ? {
                              code: key,
                              label: get(this.annotationOptions, `${key}.label`, ""),
                          }
                        : null;
                })
                .filter(v => v !== null);
        },
    },
};
</script>

<style lang="sass" scoped>
.search-guarantees
    margin: 8px
</style>
